import { Menu, Bell, Settings } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useUserStore } from '@/stores/useUserStore'

interface HeaderProps {
  onMenuClick?: () => void
}

export function Header({ onMenuClick }: HeaderProps) {
  const { level } = useUserStore()

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between px-4 py-3 bg-gradient-to-b from-bg-surface to-transparent safe-top">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="w-10 h-10 flex items-center justify-center bg-bg-card rounded-xl text-text-primary hover:bg-primary/20 transition-colors"
          aria-label="Menu"
        >
          <Menu size={20} />
        </button>
        <h1 className="font-display font-bold text-xl text-gradient">
          WAIFUDO
        </h1>
      </div>

      <div className="flex items-center gap-2">
        <span className="px-3 py-1.5 bg-gradient-to-r from-secondary to-secondary-dark rounded-full text-sm font-bold shadow-glow-purple">
          Lv. {level}
        </span>
        <button
          className="w-10 h-10 flex items-center justify-center bg-bg-card rounded-xl text-text-secondary hover:text-primary transition-colors"
          aria-label="Notifications"
        >
          <Bell size={18} />
        </button>
        <Link
          to="/settings"
          className="w-10 h-10 flex items-center justify-center bg-bg-card rounded-xl text-text-secondary hover:text-primary transition-colors"
          aria-label="Settings"
        >
          <Settings size={18} />
        </Link>
      </div>
    </header>
  )
}
